import styled from 'styled-components'

interface InfoListType {
  label: string
  value: string
}

interface UserInfoTextLayoutDesktopProps {
  title: string
  list: InfoListType[]
  className?: string
}

const UserInfoTextLayoutDesktop = ({
  list,
  title,
  className,
}: UserInfoTextLayoutDesktopProps) => {
  return (
    <StyledWrapper className={className}>
      <p>{title}</p>
      <ul>
        {list.map((item, index) => (
          <li key={`${item.label}-${index}`}>
            <div>
              <label>{item.label}</label>
              <p>{item.value} </p>
            </div>
          </li>
        ))}
      </ul>
    </StyledWrapper>
  )
}

export default UserInfoTextLayoutDesktop

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  align-self: flex-start;

  > p {
    font-size: 18px;
    font-weight: bold;
    letter-spacing: -0.72px;
    text-align: left;
    color: #333;
  }

  > ul {
    display: flex;
    flex-direction: column;
    gap: 12px;

    > li {
      list-style: disc;
      list-style-position: inside;

      > div {
        display: inline-flex;

        > label {
          width: 74px;
          font-size: 15px;
          font-weight: 500;
          line-height: 1.47;
          letter-spacing: -0.6px;
          text-align: left;
          color: #333;
        }

        > p {
          width: max-content;
          font-size: 15px;
          font-weight: normal;
          line-height: 1.47;
          letter-spacing: -0.6px;
          text-align: left;
          color: #333;
        }
      }
    }
  }
`
